import { WORKOUT_SECTION_KEY } from '../../../workout-section/model'
import setReduxAction from '../../../redux/actions/set'
import { getValueReduxUtil } from '../../../redux/utils/get-value'
import { START_WORKOUT_ACTION, START_WORKOUT_PATH } from '../../constants'
import { WORKOUT_EXERCISES_PATH } from '../../../workout-exercise/redux/constants'
import updateCurrentWorkoutSectionAction from '../../../workout-section/redux/actions/update-current'
import getByIdWorkoutSectionSelector from '../../../workout-section/redux/selectors/get-by-id'

function updateWorkoutSectionStartWorkoutAction (id, workoutExerciseIndex, setIndex) {
  return (dispatch, getState) => {
    const workoutSection = getByIdWorkoutSectionSelector(id)(getState())
    if (!workoutSection) {
      return
    }
    dispatch(setReduxAction({
      type: START_WORKOUT_ACTION.UPDATE_WORKOUT_SECTION,
      payload: {
        paths: [
          START_WORKOUT_PATH.CURRENT_WORKOUT_SECTION_INDEX,
          START_WORKOUT_PATH.CURRENT_WORKOUT_EXERCISE_INDEX,
          WORKOUT_EXERCISES_PATH.CURRENT_SET_INDEX
        ],
        values: [
          getValueReduxUtil(workoutSection, WORKOUT_SECTION_KEY.ORDER) - 1,
          workoutExerciseIndex || 0,
          setIndex || 0
        ]
      }
    }))
    dispatch(updateCurrentWorkoutSectionAction(workoutSection))
  }
}

export { updateWorkoutSectionStartWorkoutAction }
